import { render, staticRenderFns } from "./agentStatistics.vue?vue&type=template&id=baf8856a&scoped=true&"
import script from "./agentStatistics.vue?vue&type=script&lang=js&"
export * from "./agentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./agentStatistics.vue?vue&type=style&index=0&id=baf8856a&scoped=true&lang=css&"
import style1 from "./agentStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf8856a",
  null
  
)

export default component.exports